import { t } from "../i18n";

export const NormalHourSelection = ({ hours, selected, onSelect }) => {
	const labels = [t("Por la mañana"), t("Por la tarde")];
	const classSuffix = ["morning", "afternoon"];

	const noGroupsWithHours = hours?.every(
		(group) => !group || group.length === 0
	);

	if (noGroupsWithHours) {
		return (
			<div className="content_time_info no-availability">
				<h4>{t("No se han podido cargar las horas disponibles")}</h4>
				<p>
					{t(
						"Por favor, intenta de nuevo más tarde o contáctanos para ayudarte a gestionar tu cita."
					)}
				</p>
			</div>
		);
	}

	return (
		<div className="content_time">
			{hours?.map((hourGroup, index) => (
				<div
					key={index}
					className={`content_time_${classSuffix[index]}`}
				>
					<p className="content_time_header">{labels[index]}</p>
					{hourGroup?.length > 0 ? (
						<div className="content_time_slots">
							{hourGroup.map((hour, hourIndex) => (
								<span
									key={hourIndex}
									className={`kensei_03${
										selected === hour ? " selected" : ""
									}`}
									onPointerDown={onSelect(hour)}
								>
									{hour}
								</span>
							))}
						</div>
					) : (
						<p className="no-availability">
							{t("No hay horas disponibles para este horario.")}
						</p>
					)}
				</div>
			))}
		</div>
	);
};
